<template>
	<div id="auditTop" class="main-page-content">
		<PageHeaderLayout :isBack="true">
			<div style="background: #fff; padding: 20px 20px">
				<el-form :inline="true" :model="searchCondition" class="demo-form-inline">
					<el-form-item label="岗位名称">
						<el-input clearable v-model="searchCondition.recruit_post" placeholder="请输入岗位名称"></el-input>
					</el-form-item>
					<el-form-item label="姓名">
						<el-input clearable v-model="searchCondition.fullName" placeholder="请输入姓名"></el-input>
					</el-form-item>

					<el-form-item>
						<el-button type="primary" @click="searchButton">查询</el-button>
					</el-form-item>
				</el-form>
				<div style="marrgin: 0 20px">
					<el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#fbfbfb' }">
						<template v-if="activeName === '2'">
							<el-table-column prop="recruit_post" label="岗位名称" align="center"></el-table-column>
							<el-table-column prop="fullName" label="姓名" align="center"></el-table-column>
							<el-table-column prop="sex" label="性别" align="center"></el-table-column>
							<el-table-column prop="age" label="年龄" align="center"></el-table-column>
							<el-table-column prop="phone" label="联系电话" align="center"></el-table-column>
							<el-table-column prop="degree" label="学历" align="center">
								<template slot-scope="scope">
									{{ degree_rext[scope.row.degree||0] }}
								</template>
							</el-table-column>
							<el-table-column prop="resume" label="简历" align="center">
								<template slot-scope="scope">
									<div  style="color:#1890ff;cursor: pointer;"
                @click="lookResume(scope.row)">查看</div>
								</template>
							</el-table-column>
						</template>

						<el-table-column prop="examine_status" label="状态" align="center">
							<template slot-scope="scope">
								{{ options_text[scope.row.examine_status] }}
							</template>
						</el-table-column>
						<el-table-column label="操作" align="center">
							<template slot-scope="scope">
								<el-button v-if="scope.row.examine_status == '0'" size="mini" type="primary" @click="showExamine(scope.row)">审核</el-button>
								<!-- <el-button size="mini" @click="taskClick(scope.row)">详情</el-button> -->
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>

			<el-dialog title="提示" :visible.sync="examinedialogVisible" width="50%" @close="closeExamine">
				<el-radio-group v-model="examinedialog.examine_status">
					<el-radio :label="1">审核通过</el-radio>
					<el-radio :label="2">审核拒绝</el-radio>
				</el-radio-group>
				<!-- <div v-if="examinedialog.examine_status == 2" style="margin-top: 30px">
					<el-form label-width="90px" ref="userRef">
						<el-form-item prop="textarea">
							<el-input type="textarea" placeholder="请输入内容" v-model="examinedialog.reamerk" maxlength="100" show-word-limit :rows="5"></el-input>
						</el-form-item>
					</el-form>
				</div> -->
				<span slot="footer" class="dialog-footer">
					<el-button @click="closeExamine">取 消</el-button>
					<el-button type="primary" @click="examineClick">确 定</el-button>
				</span>
			</el-dialog>

			<el-pagination
				style="float: right"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page.sync="pagege.current_page"
				:page-sizes="[10, 20, 50, 100]"
				:page-size="pagege.page_size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="pagege.total"
			></el-pagination>
		</PageHeaderLayout>
	</div>
</template>

<script>
import DatePicker from '@/components/DatePicker.vue';
import PageHeaderLayout from '@/layouts/PageHeaderLayout';
export default {
	components: {
		DatePicker,
		PageHeaderLayout
	},
	data() {
		return {
			query: {},
			shenheData: [],
			activeName: '2',
			degree_rext:['不限','小学','初中','高中','大专','本科及以上'],
			options_text: ['待审核', '审核通过', '审核拒绝'],
			options: [
				{
					value: '0',
					label: '待审核'
				},
				{
					value: '1',
					label: '审核通过'
				},
				{
					value: '2',
					label: '审核拒绝'
				}
			],
			searchCondition: {},
			pagege: {},
			currentPage2: '',
			id: '',
			Status: '',
			mission_content: '',

			examinedialogVisible: false,
			examinedialog: {
				row: {},
				examine_status: 1,
				reamerk: ''
			},
			taskseedialogVisible: false,
			tableData: [],
			ispage: 1,
			num: 10
		};
	},
	created() {
		this.query = this.$route.query;
		this.init();
	},

	methods: {
		// 搜索
		searchButton() {
			this.init();
		},
		//获取选中日期的值
		dataSearch(value) {
			console.log(value);
			this.searchCondition.time = {};
			this.searchCondition.time.start_time = value[0];
			this.searchCondition.time.end_time = value[1];
		},
		handleClick(tab) {
			this.activeName = tab.name;
			this.init();
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.num = val;
			this.ispage = 1;
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.ispage = val;
			this.init();
		},
		closeExamine() {
			this.examinedialogVisible = false;
		},
		showExamine(row) {
			this.examinedialogVisible = true;
			this.examinedialog.row = row;
		},
		lookResume(row){
			if(!row.resume){
				this.$message.warning('未上传简历')
				return 
			}
			window.open(row.resume)
		},
		//详情
		taskClick(row) {
			this.$router.push({ path: '/deliveryPersonnelDetail', query: { id: row.join_id } });
		},
		async init() {
			let objects = {
				current_page: this.ispage,
				page_size: this.num,
				fullName: this.searchCondition.fullName,
				recruit_post: this.searchCondition.recruit_post,

				post_id: this.query.post_id
			};
			let res = {};
			res = await this.$api.postDaily_postjoin_list(objects);
			let { data, pages } = res;
			console.log(data, '321312312312');
			console.log(pages);
			this.tableData = data;
			this.pagege = pages;
		},

		taskseeClick(row) {
			this.mission_content = row.mission_content || row.job_remark;
			console.log(row);
			this.taskseedialogVisible = true;
		},

		async examineClick() {
			let params = {
				id: this.examinedialog.row.id,
				examine_status: this.examinedialog.examine_status
			};
			await this.$api.postDaily_postAudit(params);
			this.examinedialog = {
				examine_status: '1',
				reamerk: ''
			};
			this.closeExamine()
			this.init()
			this.$message.success('审核成功');
		},
		async userInfo() {
			let obj = {
				examine_status: this.radio,
				examine_reason: this.userList.textarea
			};
			console.log(obj, 'obj');

			if (obj.examine_status == 2 && obj.examine_reason == '') {
				this.$message.error('请填写拒绝理由');
			} else {
				let Status = '';
				if (this.activeName === '1') {
					Status = await this.$api.postStatus(this.id, obj);
				} else {
					Status = await this.$api.postDaily_taskExamine(this.id, obj);
				}
				this.$nextTick(() => {
					if (Status) {
						this.$message.success('审核成功!');
						this.init();
						this.examinedialogVisible = false;
					}
				});
			}
		}
	}
};
</script>

<style scoped lang="scss">
.main-page-content {
	padding-bottom: 50px;
}
</style>
